"use client";
import { getEnv } from "@/env";
import useLogistrationTest from "@/monarch/rules/logistrationTest/useLogistrationTest";
import { DEFAULT_AUTH_DOMAIN } from "@/lib/course/utils/constants";

export const DEFAULT_AUTH_MODE = "register";

/**
 * Get the auth base url, this may end in a `/` so don't start with one unless you want to start at site root
 *
 * (Auth for RV is in a subdirectory)
 */
export const useAuthBaseURL = () => {
  let base = new URL(
    getEnv("NEXT_PUBLIC_AUTHN_BASE_URL") ?? DEFAULT_AUTH_DOMAIN,
  );

  let result = useLogistrationTest();

  if (
    !result.isLoading &&
    result.variant == "test" &&
    getEnv("NEXT_PUBLIC_FEATURE_ENABLE_LOGIN") === "true"
  ) {
    base = new URL("/auth/", window.location.href);
  }

  return base.toString();
};
